import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=0088f50c&scoped=true&lang=pug&"
import script from "./DeviceDetails.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=0088f50c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0088f50c",
  null
  
)

component.options.__file = "DeviceDetails.vue"
export default component.exports